import client from 'FrontendJsAssets/common/client'
import { CancelToken } from 'axios'

const lang = document.querySelector('html').getAttribute('lang')
let generalError

import(`../locale/${lang}`).then((module) => {
    generalError = module.GeneralError
})

class rFavoriteTrigger extends HTMLElement {
    get url() {
        return !this.isFavorite ? this.addUrl : this.removeUrl
    }

    constructor() {
        super()

        this.isLoading = false
        this.isFavorite = false

        this.handleTrigger = this.handleTrigger.bind(this)
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.productId = this.dataset.productId
            this.addUrl = `/pridat-oblubeny-produkt/${this.productId}`
            this.removeUrl = `/odstranit-oblubeny-produkt/${this.productId}`
            this.refreshListing = this.dataset.refreshListing

            this.addIcon = 'ico-heart'
            this.addText = this.dataset.addText
            this.addTextShort = this.dataset.addTextShort
            this.removeIcon = 'ico-heart-full'
            this.removeText = this.dataset.removeText
            this.removeTextShort = this.dataset.removeTextShort

            this.icon = this.querySelector('.ico')
            this.text = this.querySelector('.is-text')
            this.textShort = this.querySelector('.is-text-short')
            this.productSum = this.querySelector('.is-product-sum')
            this.thumb = this.closest('.js-thumb')

            if (this.classList.contains('is-in-favorites')) {
                this.isFavorite = true
            }

            this.addEventListener('click', this.handleTrigger)
            this.addEventListener('keypress', this.handleTrigger)
        })
    }

    toggleAttributes() {
        this.classList.toggle('is-in-favorites', this.isFavorite)

        if (this.icon) {
            this.icon.classList.toggle(this.addIcon, !this.isFavorite)
            this.icon.classList.toggle(this.removeIcon, this.isFavorite)
        }

        this.setAttribute('title', this.isFavorite ? this.removeText : this.addText)

        if (this.text) {
            this.text.innerHTML = this.isFavorite ? this.removeText : this.addText
        }

        if (this.textShort) {
            this.textShort.innerHTML = this.isFavorite ? this.removeTextShort : this.addTextShort
        }

        if (this.thumb) {
            this.thumb.classList.toggle('is-in-favorites', this.isFavorite)
        }
    }

    handleLoading(loadingState) {
        this.isLoading = loadingState

        if (this.classList.contains('c-btn')) {
            this.classList.toggle('is-loading', loadingState)
        } else {
            this.icon.classList.toggle('is-loading', loadingState)
        }
    }

    handleAlert(message, type) {
        window.Eshop.tippyAlert(this.classList.contains('c-btn') ? this : this.icon, message, {
            theme: type,
            placement: 'top-start'
        })
    }

    handleTrigger(event) {
        event.preventDefault()

        if (event.type == 'keypress' && ![13,32].includes(event.charCode))
            return

        this.handlePost()
    }

    handlePost() {
        if (this.isLoading)
            return

        this.handleLoading(true)

        client.post(this.url)
            .then((response) => {
                const data = response.data

                if (data.status) {
                    this.isFavorite = !this.isFavorite

                    for (const favoriteCount of document.querySelectorAll('.js-favorite-count')) {
                        favoriteCount.dataset.count = data.count
                        favoriteCount.innerHTML = data.count
                    }

                    if (this.productSum) {
                        const oldSum = parseInt(this.productSum.innerText) || 0
                        let newSum = oldSum + (this.isFavorite ? 1 : -1)
                        newSum = newSum < 0 ? 0 : newSum

                        this.productSum.innerText = newSum <= 0 ? '' : newSum
                        this.dataset.sum = newSum
                    }

                    if (this.refreshListing) {
                        this.refreshCurrentListingPage()
                    }
                } else {
                    if (data.errorType === 'not_present') {
                        if (this.refreshListing) {
                            this.refreshCurrentListingPage()
                        } else {
                            this.isFavorite = false
                        }
                    }
                }

                this.handleAlert(data.message, data.status ? 'success' : 'error')
            })
            .catch((error) => {
                this.handleAlert(generalError, 'error')
            })
            .then(() => {
                this.handleLoading(false)
                this.toggleAttributes()
            })
    }

    refreshCurrentListingPage(tryPrevious = false) {
        let urlToFetch = window.location.href

        if (tryPrevious) {
            const pagerPrevEl = document.querySelector('.pager__list .c-btn.is-prev')

            if (!pagerPrevEl) {
                return
            }

            urlToFetch = pagerPrevEl.getAttribute('href')
        }

        for (const listingHolder of document.querySelectorAll('.listing__holder')) {
            listingHolder.classList.add('is-loading')
        }

        client.get(urlToFetch)
            .then((response) => {
                window.Listing.callbacks.update(response.data)
            })
            .catch((error) => {
                if (!tryPrevious) {
                    this.refreshCurrentListingPage(true)
                }
            })
    }
}

customElements.define('r-favorite-trigger', rFavoriteTrigger)

export default rFavoriteTrigger